/**
 * Local deterministic placeholder image generation.
 * Ported from dextoro-seedbot/src/placeholder-images.ts for browser use.
 * Generates a colored circle with the seed's first letter, using btoa() instead of Node Buffer.
 */

const PALETTE = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
  '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
  '#F0B27A', '#7DCEA0', '#F1948A', '#AED6F1', '#D7BDE2',
  '#A3E4D7', '#FAD7A0', '#A9CCE3', '#D5F5E3', '#FADBD8',
];

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function generatePlaceholderDataUri(seed: string): string {
  const hash = hashString(seed);
  const color = PALETTE[hash % PALETTE.length];
  const letter = (seed[0] || '?').toUpperCase();

  const svg = [
    '<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">',
    `<circle cx="256" cy="256" r="256" fill="${color}"/>`,
    `<text x="256" y="280" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="240" font-weight="bold" fill="#fff">${letter}</text>`,
    '</svg>',
  ].join('');

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}
